// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueCompositionApi from "@vue/composition-api"
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import VueMoment from 'vue-moment'
import router from './router'
import Notify from 'vue2-notify'
import VueI18n from 'vue-i18n'

Vue.config.productionTip = false
Vue.use(VueCompositionApi)
Vue.use(BootstrapVue)
Vue.use(VueMoment);
Vue.use(Notify, { visibility: 3000, position: 'top-left', itemClass: 'alert alert-meeting'})
Vue.use(VueI18n)

import ar from '../static/languages/WebRTC_ar.json'
import de from '../static/languages/WebRTC_de.json'
import el from '../static/languages/WebRTC_el.json'
import en from '../static/languages/WebRTC_en.json'
import es from '../static/languages/WebRTC_es.json'
import fi from '../static/languages/WebRTC_fi.json'
import fr from '../static/languages/WebRTC_fr.json'
import hi from '../static/languages/WebRTC_hi.json'
import it from '../static/languages/WebRTC_it.json'
import ja from '../static/languages/WebRTC_ja.json'
import kk from '../static/languages/WebRTC_kk.json'
import ko from '../static/languages/WebRTC_ko.json'
import ne from '../static/languages/WebRTC_ne.json'
import nl from '../static/languages/WebRTC_nl.json'
import pt from '../static/languages/WebRTC_pt.json'
import ro from '../static/languages/WebRTC_ro.json'
import ru from '../static/languages/WebRTC_ru.json'
import sk from '../static/languages/WebRTC_sk.json'
import tr from '../static/languages/WebRTC_tr.json'
import ur from '../static/languages/WebRTC_ur.json'
import zh from '../static/languages/WebRTC_zh.json'

var i18n = new VueI18n({
  locale: 'en',
  messages: {
    ar: ar,
    de: de,
    el: el,
    en: en,
    es: es,
    fi: fi,
    fr: fr,
    hi: hi,
    it: it,
    ja: ja,
    kk: kk,
    ko: ko,
    ne: ne,
    nl: nl,
    pt: pt,
    ro: ro,
    ru: ru,
    sk: sk,
    tr: tr,
    ur: ur,
    zh: zh
  }
})

if (!String.prototype.includes) {
  // eslint-disable-next-line
  String.prototype.includes = function (search, start) {
    'use strict'
    if (typeof start !== 'number') {
      start = 0
    }
    if (start + search.length > this.length) {
      return false
    } else {
      return this.indexOf(search, start) !== -1
    }
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n: i18n,
  components: { App },
  data: {
    api: {}
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js